// @ts-ignore
import {Tooltip} from 'bootstrap';

document.addEventListener('DOMContentLoaded', function () {
    const selector = '[data-bs-toggle="tooltip"]';
    Array.from(document.querySelectorAll(selector)).forEach(popover => {
      new Tooltip(popover, {
        trigger: 'hover'
      });
    });
});


const button = document.querySelector('#button');
